import { lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  statLabel: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: 8
  },
  statValue: {
    fontSize: 22,
    fontWeight: 600
  },
  okBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 16,
    backgroundColor: lighten(theme.palette.secondary.light, 0.8),
    fontSize: 13,
    fontWeight: 500
  },
  warningBadge: {
    backgroundColor: lighten(theme.palette.warning.light, 0.8)
  },
  warningIcon: {
    color: theme.palette.warning.dark,
    fontSize: 18,
    marginBottom: 2
  },
  warningText: { color: theme.palette.warning.dark, fontSize: 12 },
  okSection: {
    display: 'flex',
    alignItems: 'center'
  },
  okIcon: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    marginBottom: 2
  },
  trueText: { color: theme.palette.secondary.main, fontSize: 13 },
  inProgressBadge: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e3f2fd',
    padding: 6,
    borderRadius: 12
  },
  inProgressIcon: {
    color: '#2196f3',
    marginRight: 4
  },
  inProgressText: {
    color: '#2196f3',
    fontSize: 12
  }
}))
export default useStyles
